import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('user-areas-selected-showcase', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('user-areas-selected-showcase');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
